
import React, {useEffect, useState} from "react";
import SelectedRowInfoBox from "../../../create-report/shared-components/SelectedRowInfoBox.js";
import ReportTypography from "../../../create-report/shared-components/ReportTypography.js";
import {renderTextField} from "../annexes/annexes_components.js";
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import MappedText from "../../../../../study-page/create-study/analysis-page/components/clinical-info/mapText.js";
import { renderToStringAlt } from "../../../create-report/shared-components/renderToString.js";


function Interpretation({variants, handleSectionUpdate, variant_type, analysisType}){


    const [variants_data, setVariantData] = useState([]);
    const [interpretation, setInterpretation] = useState({ conclusions: "", recommendations: "" });



    const handleInterpretationChange = (event) => {
        const { name, value } = event.target;
        setInterpretation(prevState => ({
            ...prevState,
            [name]: value
        }));
        handleSectionUpdate({
            rows: variants_data,
            conclusions: name === 'conclusions' ? value : interpretation.conclusions,
            recommendations: name === 'recommendations' ? value : interpretation.recommendations
        }, "Interpretation");
    }

    useEffect(function(){

        if(variants && variants.rows){
            setVariantData(variants.rows)
        }

    }, [variants])






    const handleTextChange = (index, value) => {

      // get prevState of the Tagged Treatments and update comment;
      setVariantData((prevState) => {
        const updatedVariants = [...prevState];
        updatedVariants[index].comments = value;
        handleSectionUpdate(
          {
            rows: updatedVariants,
            conclusions: interpretation.conclusions,
            recommendations: interpretation.recommendations,
          },
          "Interpretation",
          variant_type
        );
        return updatedVariants;
      });
    };




    const renderInfoBoxes = () => {

        let fields;
        let dataType = "variant"

        return variants_data.map((s,i) => {

            const selected= true;
            let elementKey = s.geneName + "_"+ i;

            if(analysisType === "somatic_fusion_analysis"){
                
                fields =  { "field1": s.fusioned_genes,
                    "field2": s.significance, 
                    "field3": "",
                    "field4": s.left_breakpoint + " and " + s.right_breakpoint,};

                    elementKey = s.fusioned_genes + "_"+ i;    

                    dataType = "fusion";
            }
            else
            {
                // TODO: review transcript format and difference SNV vs CNV
                let field1;
                if (s.transcript && s.transcript !== 'None') {
                    field1 = s.transcript;  
                } else  {
                    field1 = s.sv_type;
                }

                // difference CNV vs SNV
                let positionField;
                if(s.start_pos){

                    let end_pos = (s.end_pos) ? ":" + s.end_pos : "";
                    positionField = s.chromosome  + ":"+ s.start_pos + end_pos;

                }
                else{

                    //positionField = s.chromosome  + ":"+ s.SV_start + ":" + s.SV_end;
                    positionField    = "//"
                }

                fields =  { "field1": field1,
                    "field2": field1 !== s.sv_type ? s.geneName : null, 
                    "field3": s.cDNA,
                    "field4": positionField,};
                
                   
            }
          
           
            return (
                <SelectedRowInfoBox
                    key={elementKey}
                    fields={fields}
                    comments={s.comments}
                    selected={selected}
                    dataType={dataType}
                    handleOnTextChange={(event) => handleTextChange(i, event.target.value)}
                />
            );
        });
    }

    return (<>
        <ReportTypography text={renderToStringAlt("These are the interpretation comments that were written in each variant tag.")}/>
        <ReportTypography text={renderToStringAlt("The original tag comment will not be modified here. Your modifications will only be visible in the exported report.")}/>
        <Box p={1}>
            {renderInfoBoxes()}
        </Box>
        <Box p={1}>
            <Typography variant={"h6"}><MappedText text="Conclusion"/></Typography>
            {renderTextField("", "", handleInterpretationChange, "conclusions" )}
        </Box>
        {
            (analysisType === "germline")
                ? <Box p={1}>
                    <Typography variant={"h6"}><MappedText text="Recommendations"/></Typography>
                    {renderTextField("", "", handleInterpretationChange, "recommendations" )}
                </Box>
                : null

        }


{/*
        default value empty
*/}

        </>)

}



export default Interpretation;